export default __webpack_public_path__ + "static/logo-white-663b4639656572590d5a6fafe1a57a24.svg";